var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87313 17.129C5.02813 15.819 3.56813 14.115 2.74313 13.039C2.51244 12.742 2.38721 12.3766 2.38721 12.0005C2.38721 11.6244 2.51244 11.259 2.74313 10.962C4.23613 9.013 7.81813 5 12.0001 5C13.8761 5 15.6301 5.807 17.1301 6.874",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.13 9.887C13.8523 9.60467 13.5214 9.38011 13.1565 9.22628C12.7916 9.07246 12.3998 8.99241 12.0038 8.99075C11.6078 8.98909 11.2153 9.06586 10.8491 9.21662C10.4829 9.36738 10.1502 9.58916 9.87014 9.86915C9.59008 10.1491 9.36822 10.4818 9.21738 10.848C9.06653 11.2142 8.98967 11.6066 8.99123 12.0026C8.9928 12.3986 9.07276 12.7904 9.2265 13.1554C9.38024 13.5203 9.60472 13.8512 9.88698 14.129",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20L20 4",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.704C10.6492 18.8972 11.3227 18.9969 12 19C16.182 19 19.764 14.987 21.257 13.038C21.4876 12.7407 21.6127 12.3751 21.6126 11.9988C21.6124 11.6226 21.4869 11.2571 21.256 10.96C20.7313 10.2755 20.1684 9.62112 19.57 9",
    stroke: "#C7C7C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVisibility);
export default __webpack_public_path__ + "static/media/ic_visibility.a86f2b8490819ec38df27930d84e1be3.svg";
export { ForwardRef as ReactComponent };